import { useContext, useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { Table } from 'react-bootstrap'

import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'

import { SocketContext } from '../../context/SocketContext'
import { useHideMenu } from '../../hooks/useHideMenu'
import { useGetPantallas } from '../../hooks/useGetPantallas'
import { getUsuarioStorage } from '../../helpers/getUsuarioStorage'

import LoadingOverlay from '../../components/LoadingOverlay'
import { NoAcceso } from '../../components/NoAcceso'
import { serverApi } from '../../api'
import { CrearUbicacionModal } from './components/CrearUbicacionModal'



const pasarMayusculas = (ev) => {
    ev.target.value = ev.target.value.toUpperCase();
}


const MySwal = withReactContent(Swal);
const sweet = (title, html, icon) => { MySwal.fire({ title, html, icon, confirmButtonColor: 'LightSeaGreen', timer: 15000 }) }
const sweetConfirm = (title, html, icon) => {
    return MySwal.fire({

        title,
        html,
        icon,
        confirmButtonText: 'Ok',
        confirmButtonColor: 'LightSeaGreen',
        showCancelButton: true,
        cancelButtonColor: '#d33',
        cancelButtonText: 'Cancelar'
    })
}


export const UbicacionesCreacion = () => {

    let [usuario] = useState(getUsuarioStorage());
    const pantallas = useGetPantallas();
    const navigate = useNavigate();
    const { socket } = useContext(SocketContext);

    useHideMenu(false);

    const [isLoading, setIsLoading] = useState(false);
    const [showModal, setShowModal] = useState(false);

    // const [ubicaciones, setUbicaciones ] = useState([]);


    const [searchInput, setSearchInput] = useState('');

    const [query, setQuery] = useState({
        search: '',
        page: 1,
        limit: 10,
        sortBy: 'ubicacion',
        sortDir: 'asc',
    });
    const [data, setData] = useState([]);
    const [total, setTotal] = useState(0);
    const totalPages = Math.max(1, Math.ceil(total / query.limit));


    useEffect(() => {
        if (!usuario?.uidUsuario) navigate('/Ingreso');
    }, [usuario, navigate]);

    //Carga inicial de los Ubicaciones
    useEffect(() => {
        const load = async () => {

            const codigoEntidad = usuario.codigoEntidad;
            if (!codigoEntidad) return;

            try {
                setIsLoading(true);

                const resp = await serverApi.post('/ubicaciones/lista-ubicaciones', {
                    ...query,
                    codigoEntidad,
                });

                console.log(resp.data);

                setData(resp.data.listaUbicaciones || []);
                setTotal(resp.data.total || 0);

            } catch (error) {
                console.error(error);
            } finally {
                setIsLoading(false);
            }
        };

        load();
    }, [query, usuario]);

    useEffect(() => {

        if (!socket) return;


        const handler = (lista) => {
            console.log(lista);
            setData(lista.listaUbicaciones);
            setTotal(lista.total || 0);
        };

        socket.on('lista-ubicaciones', handler);

        return () => socket.off('lista-ubicaciones', handler);

    }, [socket])

    // const handleSearch = (ev) => {
    //     setQuery(prev => ({
    //         ...prev,
    //         search: ev.target.value,
    //         page: 1
    //     }));
    // };

    useEffect(() => {
        const timeout = setTimeout(() => {

            if (searchInput.trim().length > 0 && searchInput.trim().length < 2) return;

            setQuery(prev => {
                if (prev.search === searchInput) return prev; // 🔥 evita re-render

                return {
                    ...prev,
                    search: searchInput,
                    page: 1
                };
            });

        }, 1000);

        return () => clearTimeout(timeout);

    }, [searchInput]);

    const paginate = (page) => {
        if (page < 1 || page > totalPages) return;

        setQuery(prev => ({
            ...prev,
            page
        }));
    };

    const handleSort = (field) => {
        setQuery(prev => ({
            ...prev,
            sortBy: field,
            sortDir: prev.sortDir === 'asc' ? 'desc' : 'asc'
        }));
    };



    const inactivaUbicacion = async (ideUbicacion, accion) => {

        const codigoEntidad = usuario.codigoEntidad;
        if (!codigoEntidad || codigoEntidad === null) return sweet('Atención!', 'Revise la infromación', 'error');

        const act = accion === 1 ? "Activar" : "Inactivar";

        const confirmacion = await sweetConfirm("Atención", `Esta seguro de ${act} el registro?`, "warning").then((result) => {
            return (result);
        })

        if (!confirmacion.value) return false;

        // uidModulo= uidModulo;
        // datos.accion= accion;

        try {

            await serverApi.post(
                `/ubicaciones/inactiva-ubicacion`,
                {
                    ...query,
                    accion,
                    codigoEntidad,
                    ideUbicacion,
                }
            );

        } catch (error) {
            console.error(error);
        } finally {
            setIsLoading(false);
        }

    }


    const registraUbicacion = async (datos) => {

        const codigoEntidad = localStorage.getItem("codigoEntidad");
        if (!codigoEntidad || codigoEntidad === null) return sweet('Atención!', 'Revise la infromación', 'error');

        try {

            setIsLoading(true);
            const res = await serverApi.post(
                `/ubicaciones/registra-ubicacion`,
                {
                    ...query,
                    ...datos,
                    codigoEntidad,

                }
            );

            if (res.data.ok === false) {
                sweet('', res.data.resp, 'error');
            } else {
                sweet('', res.data.resp, 'success');
                setShowModal(false)
            }


        } catch (error) {
            // sweet('Atención!', res[1], 'error');
            console.error(error);
        } finally {
            setIsLoading(false);

        }


    }

    const editaUbicacion = async (ev, ideUbicacion) => {

        const campo = ev.target.id.split("_")[0];
        const valor = (ev.target.type === 'checkbox') ? ev.target.checked : ev.target.value;
        const valorAnterior = (ev.target.type === 'checkbox') ? ev.target.checked : ev.target.defaultValue;


        if (valor !== valorAnterior || ev.target.type === 'checkbox') {

            const confirmacion = await sweetConfirm("Atención", "Esta seguro de Modificar el registro?", "warning");
            if (!confirmacion.value) {

                // restaurar visualmente checkbox
                if (ev.target.type === 'checkbox') {
                    ev.target.checked = valorAnterior;
                } else {
                    ev.target.value = valorAnterior;
                }

                return;
            }

            try {
                const codigoEntidad = usuario.codigoEntidad;

                if (!codigoEntidad || codigoEntidad === null) return sweet('Atención!', 'Revise la infromación', 'error');

                await serverApi.post(
                    `/ubicaciones/edita-ubicacion`,
                    {
                        ...query,
                        campo,
                        valor,
                        codigoEntidad,
                        ideUbicacion,
                    }
                );



            } catch (error) {
                console.error(error);

            } finally {
                setIsLoading(false);
            }
        }


    }



    if (usuario.uidUsuario === null) {
        return (
            <>
            </>
        )
    }
    else if (!pantallas.includes("creacionubicaciones")) {
        return (<NoAcceso />)
    }
    else {

        return (
            <>
                {isLoading && <LoadingOverlay />}
                <div className={`content ${isLoading ? 'opacity' : ''} m-5`} style={{ minHeight: '100vh' }}>

                    <div>

                        <div className='col-lg-2 col-12'>

                            <button
                                className="btn btn-success mb-3"
                                onClick={() => setShowModal(true)}
                            >
                                Crear Ubicaciones/Sedes
                            </button>

                            <CrearUbicacionModal
                                show={showModal}
                                onClose={() => setShowModal(false)}
                                onSave={(data) => {
                                    registraUbicacion(data)

                                }}
                            />

                        </div>




                        <div className='row rounded shadow p-3'>

                            <div className='col-12'>
                                <div className='float-start col-lg-4 col-12 pagination'>

                                    <button
                                        className='btn btn-sm btn-secondary m-1'
                                        onClick={() => paginate(query.page - 1)}
                                        disabled={query.page === 1}
                                    >
                                        {'<'}
                                    </button>

                                    <button
                                        className='btn btn-sm btn-secondary m-1'
                                        onClick={() => paginate(query.page + 1)}
                                        disabled={query.page >= totalPages}

                                    >
                                        {'>'}
                                    </button>

                                </div>

                                <div className=' float-end col-lg-4 col-12'>

                                    <input
                                        type='text'
                                        placeholder='Buscar...'
                                        className='form-control'
                                        maxLength={20}
                                        value={searchInput}
                                        onChange={(ev) => setSearchInput(ev.target.value)}
                                    />

                                </div>

                            </div>

                            <div className='col-12'>
                                <Table responsive="md" striped hover style={{ minWidth: 600 }} className='max400'>
                                    <thead>
                                        <tr>
                                            <th width={'5%'}></th>
                                            <th width={'45%'} onClick={() => handleSort('nombreUbicacion')} >
                                                Ubicación
                                                {query.sortBy === 'nombreUbicacion' && query.sortDir === 'asc' && '▲'}
                                                {query.sortBy === 'nombreUbicacion' && query.sortDir === 'desc' && '▼'}
                                            </th>
                                            <th width={'45%'} onClick={() => handleSort('codigoUbicacion')} >
                                                Código Ubicacion
                                                {query.sortBy === 'codigoUbicacion' && query.sortDir === 'asc' && '▲'}
                                                {query.sortBy === 'codigoUbicacion' && query.sortDir === 'desc' && '▼'}
                                            </th>

                                        </tr>
                                    </thead>
                                    <tbody width={'100%'}  >

                                        {

                                            data.length === 0
                                                ? (<tr>
                                                    <td width={'100%'} style={{ textAlign: 'center' }}> No Hay Registros </td>
                                                </tr>
                                                )
                                                :
                                                data.map((item) => (

                                                    <tr key={item.ideUbicacion}>
                                                        <td width={'5%'}>

                                                            {(item.indActivo === 1)
                                                                ? (
                                                                    <button
                                                                        className='btn btn-sm btn-danger'
                                                                        onClick={() => inactivaUbicacion(item.ideUbicacion, 0)}
                                                                    >
                                                                        <i className='fa-solid fa-minus'></i>
                                                                    </button>
                                                                )
                                                                : (
                                                                    <button
                                                                        className='btn btn-sm btn-success'
                                                                        onClick={() => inactivaUbicacion(item.ideUbicacion, 1)}
                                                                    >
                                                                        <i className='fa-solid fa-plus'></i>
                                                                    </button>
                                                                )

                                                            }



                                                        </td>



                                                        <td width={'45%'}>
                                                            {(item.indActivo === 1)
                                                                ? (
                                                                    <input
                                                                        type='text'
                                                                        className='form-control'
                                                                        id={`codigoUbicacion_${item.ideUbicacion}`}
                                                                        defaultValue={item.codigoUbicacion.toUpperCase()}
                                                                        maxLength={20}
                                                                        onBlur={(ev) => editaUbicacion(ev, item.ideUbicacion)}
                                                                        onChange={(ev) => pasarMayusculas(ev)}
                                                                    />
                                                                )
                                                                : (
                                                                    item.codigoUbicacion.toUpperCase()

                                                                )

                                                            }
                                                        </td>

                                                        <td width={'45%'}>
                                                            {(item.indActivo === 1)
                                                                ? (
                                                                    <input
                                                                        type='text'
                                                                        className='form-control'
                                                                        id={`nombreUbicacion_${item.ideUbicacion}`}
                                                                        defaultValue={item.nombreUbicacion.toUpperCase()}
                                                                        maxLength={20}
                                                                        onBlur={(ev) => editaUbicacion(ev, item.ideUbicacion)}
                                                                        onChange={(ev) => pasarMayusculas(ev)}
                                                                    />
                                                                )
                                                                : (
                                                                    item.nombreUbicacion.toUpperCase()

                                                                )

                                                            }
                                                        </td>


                                                    </tr>
                                                ))
                                        }
                                    </tbody>
                                </Table>
                            </div>

                            <div className='pagination'>
                                <button
                                    className='btn btn-sm btn-secondary m-1'
                                    onClick={() => paginate(query.page - 1)}
                                    disabled={query.page === 1}
                                >
                                    {'<'}
                                </button>
                                <button
                                    className='btn btn-sm btn-secondary m-1'
                                    onClick={() => paginate(query.page + 1)}
                                    disabled={query.page >= totalPages}
                                >
                                    {'>'}
                                </button>
                                <span className='m-2'>
                                    {query.page} / {totalPages}
                                </span>
                            </div>

                        </div>


                    </div>



                </div>
            </>
        )
    }
}
